import createTableStore from "ds/components/Table/store/useTableStore";

import { IDP_GROUP_COLUMN_CONFIG, IDP_GROUP_COLUMNS_STORAGE_KEY } from "./constants";

export const useIdpGroupTableStore = createTableStore({
  storageKey: IDP_GROUP_COLUMNS_STORAGE_KEY,
  config: IDP_GROUP_COLUMN_CONFIG,
});
